import React from "react";
import ScrollDown from '../components/ScrollDown';
import Header from '../components/Header/Header';
import Anime from "react-anime";
import logo from '../assets/elements/novartis_logo_pos_rgb.png';
export default ({ isActive, goToNextSlide }) => {
  const subMessage = 'Inside the Four Phases of a Clinical Trial';
  const message = 'How We Make New Medicines';
  const fadeInTitle = {
    opacity: [
      { value: 0, duration: 0, },
      { value: 1, duration: 1500, easing: 'linear'}
    ]
  }
  const handleNextSlide = () => goToNextSlide();
  return (
    <div className="component first-component">
      <div className="inner-component">
        <Header />
        <div className="title-container">
          <img className="client-logo" src={logo} alt="Novartis Logo" />
          <p className="white-text main-title">{message}</p>
          <p className="white-text centered sub-title">{subMessage}</p>
        </div>
        {isActive && (
          <Anime {...fadeInTitle}>
            <ScrollDown text={'Scroll to Follow the Science'} isWhite={true} onClickNextSlide={handleNextSlide} />
          </Anime>
        )}
      </div>
    </div>
  );
};
